module.exports = __webpack_public_path__ + "static/littleWomen7s-6920c15130910f5f6652a59178af49f1.jpg";